module.exports = __webpack_public_path__ + "media/assets/icons/health-cross-8efb35fc56d1d4dd4ace909e9e928547.svg";